import {
  RESET_GEOZONES,
  FETCH_GEOZONES_INIT,
  FETCH_GEOZONES_SUCCESS,
  FETCH_GEOZONES_FAILURE
} from './types';
import API from './api';
import utilFunction from '../../../containers/function';

export function resetGeozones() {
  return {
    type: RESET_GEOZONES,
  };
}

/*  Setting Filter  */
function fetchApiSuccess(data) {
  return {
    type: FETCH_GEOZONES_SUCCESS,
    payload: data,
  };
}

function fetchApiFailure(error) {
  console.log(error)
  return {
    type: FETCH_GEOZONES_FAILURE,
    payload: error,
  };
}

function fetchApiInit() {
  return {
    type: FETCH_GEOZONES_INIT,
  };
}

export function fetchGeozonesApi() {
  return async (dispatch) => {
    dispatch(fetchApiInit());
    try {
      let data = await API.data.getAll();

      // Sort data by alias in ascending order
      if (data && data.data && data.data.length > 0) {
        const sortedData = utilFunction.sortByField(data.data, 'alias', 'ASC');
        data.data = sortedData;
      }

      dispatch(fetchApiSuccess(data));
    } catch (error) {
      dispatch(fetchApiFailure(error));
    }
  };
}


// WEBPACK FOOTER //
// ./source/client/actions/common/geozones/index.js